/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelServizioMensaAnagraficaRowDTO } from '../model/models';
import { ServizioMensaAnagraficheListFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListServizioMensaAnagraficheRequestParams {
    filter: ServizioMensaAnagraficheListFilter;
    pageable: Pageable;
    gestioneMenseServizioId: string;
}


export interface ServizioMensaAnagraficheServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista dei richiedenti del servizio mensa.
     * Pagina di righe flat (identità genitore, riferimento Pratica, conteggio studenti attivi) dei richiedenti del servizio header-tenant. Default solo Pratiche accettate; include_non_accettate&#x3D;true include anche le altre. Filtri nominativo/email/codice_fiscale a match esatto (identità cifrata). scuola_id/classe/sezione tengono il genitore se ha almeno un figlio (sospesi compresi) con quei valori; una scuola di un altro servizio da\&#39; una lista vuota. Ogni riga riporta le iscrizioni dei figli (scuola, classe, sezione, sospeso, senza dati del minore) e se il genitore ha cancellato l\&#39;account.
     * @endpoint get /api/v1/servizi/mensa/anagrafiche
* @param requestParameters
     */
    listServizioMensaAnagrafiche(requestParameters: ListServizioMensaAnagraficheRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaAnagraficaRowDTO>;

}
